import SimpUserBadge from "components/_Pages/Profile/SimpUserBadge";
import { ICONS_MODULES_PATHS } from "components/Layout/Sidebar/components/body/content/utils/iconModulesPath";
import SVG from "components/SVG";
import { EModalExploreType } from "types/Explorer.types";
import { IUser } from "types/User.types";

interface Props {
  data: IUser;
  quantity: number | undefined;
  type: string;
  compact?: boolean;
}

export const UserItemRanking = ({ data, quantity, type, compact = false }: Props) => {
  const iconSrc =
    type === EModalExploreType.RECOGNITION
      ? ICONS_MODULES_PATHS.CONFIG.CORPORATE_VALUES
      : type === EModalExploreType.COINS
        ? ICONS_MODULES_PATHS.MARKETPLACE.COINS_MODULE
        : "";

  return (
    <div className={`flex w-full items-center justify-between rounded-xl border border-transparent text-left ${compact ? "gap-2.5 px-2.5 py-2" : "gap-3 px-3 py-2.5"}`}>
      <SimpUserBadge
        user={data || null}
        size={compact ? 34 : 44}
        fontSize={compact ? 11 : 13}
        showEmail
        showRole
      />
      <div className={`flex shrink-0 items-center rounded-full bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-200 ${compact ? "gap-1 px-2 py-0.5 text-[11px] font-semibold" : "gap-1.5 px-3 py-1 text-sm font-semibold"}`}>
        {iconSrc && <SVG src={iconSrc} width={compact ? 12 : 15} height={compact ? 12 : 15} />}
        <span>{quantity}</span>
      </div>
    </div>
  );
};
